/* Admin panel icons — small inline SVG set so we don't ship an icon
   dependency. Each icon is decorative-by-default (aria-hidden=true);
   pair with visible text or aria-label on the parent control. */
import React from "react";
var E = React.createElement;

function svg(d, opts){
  opts = opts || {};
  var size = opts.size || 16;
  var stroke = opts.stroke || "currentColor";
  var sw = opts.strokeWidth || 1.75;
  return E("svg",{width:size,height:size,viewBox:"0 0 24 24",fill:"none",stroke:stroke,strokeWidth:sw,
    strokeLinecap:"round",strokeLinejoin:"round","aria-hidden":"true",focusable:"false"}, d);
}

function Search(p){ p=p||{}; return svg([
  E("circle",{key:"c",cx:11,cy:11,r:7}),
  E("line",{key:"l",x1:21,y1:21,x2:16.65,y2:16.65})
], p); }

function Plus(p){ p=p||{}; return svg([
  E("line",{key:"v",x1:12,y1:5,x2:12,y2:19}),
  E("line",{key:"h",x1:5,y1:12,x2:19,y2:12})
], p); }

function Refresh(p){ p=p||{}; return svg([
  E("polyline",{key:"p1",points:"23 4 23 10 17 10"}),
  E("polyline",{key:"p2",points:"1 20 1 14 7 14"}),
  E("path",{key:"a",d:"M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"})
], p); }

function X(p){ p=p||{}; return svg([
  E("line",{key:"a",x1:18,y1:6,x2:6,y2:18}),
  E("line",{key:"b",x1:6,y1:6,x2:18,y2:18})
], p); }

function Check(p){ p=p||{}; return svg(
  E("polyline",{points:"20 6 9 17 4 12"})
, p); }

function Copy(p){ p=p||{}; return svg([
  E("rect",{key:"r",x:9,y:9,width:13,height:13,rx:2}),
  E("path",{key:"p",d:"M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"})
], p); }

function MoreVertical(p){ p=p||{}; return svg([
  E("circle",{key:"a",cx:12,cy:5,r:1}),
  E("circle",{key:"b",cx:12,cy:12,r:1}),
  E("circle",{key:"c",cx:12,cy:19,r:1})
], p); }

function Pause(p){ p=p||{}; return svg([
  E("rect",{key:"a",x:6,y:4,width:4,height:16}),
  E("rect",{key:"b",x:14,y:4,width:4,height:16})
], p); }

function Play(p){ p=p||{}; return svg(
  E("polygon",{points:"5 3 19 12 5 21 5 3"})
, p); }

function Key(p){ p=p||{}; return svg([
  E("path",{key:"a",d:"M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"})
], p); }

function Users(p){ p=p||{}; return svg([
  E("path",{key:"a",d:"M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"}),
  E("circle",{key:"b",cx:9,cy:7,r:4}),
  E("path",{key:"c",d:"M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"})
], p); }

function CreditCard(p){ p=p||{}; return svg([
  E("rect",{key:"a",x:1,y:4,width:22,height:16,rx:2,ry:2}),
  E("line",{key:"b",x1:1,y1:10,x2:23,y2:10})
], p); }

function DollarSign(p){ p=p||{}; return svg([
  E("line",{key:"v",x1:12,y1:1,x2:12,y2:23}),
  E("path",{key:"s",d:"M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"})
], p); }

function Clipboard(p){ p=p||{}; return svg([
  E("path",{key:"a",d:"M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"}),
  E("rect",{key:"b",x:8,y:2,width:8,height:4,rx:1,ry:1})
], p); }

function Home(p){ p=p||{}; return svg([
  E("path",{key:"a",d:"M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"}),
  E("polyline",{key:"b",points:"9 22 9 12 15 12 15 22"})
], p); }

function AlertTriangle(p){ p=p||{}; return svg([
  E("path",{key:"a",d:"M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"}),
  E("line",{key:"b",x1:12,y1:9,x2:12,y2:13}),
  E("line",{key:"c",x1:12,y1:17,x2:12,y2:17})
], p); }

function Info(p){ p=p||{}; return svg([
  E("circle",{key:"a",cx:12,cy:12,r:10}),
  E("line",{key:"b",x1:12,y1:16,x2:12,y2:12}),
  E("line",{key:"c",x1:12,y1:8,x2:12,y2:8})
], p); }

function Trash(p){ p=p||{}; return svg([
  E("polyline",{key:"a",points:"3 6 5 6 21 6"}),
  E("path",{key:"b",d:"M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"})
], p); }

function Mail(p){ p=p||{}; return svg([
  E("path",{key:"a",d:"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"}),
  E("polyline",{key:"b",points:"22,6 12,13 2,6"})
], p); }

export { Search, Plus, Refresh, X, Check, Copy, MoreVertical, Pause, Play, Key, Users,
  CreditCard, DollarSign, Clipboard, Home, AlertTriangle, Info, Trash, Mail };
